import { type FC } from 'react';

import { Typography } from '@vakantiesnl/components/src/atoms/Typography';
import { useBreakpoints } from '@vakantiesnl/components/src/utils/useBreakpoints';
import { usePriceToDecimalString } from '@vakantiesnl/services/src/hooks/utils/hook';
import { type MicroCopy } from '@vakantiesnl/types';

import { useCustomStyles } from '../PriceTable.style';

type Props = {
	totalPrice: number;
	microCopies: MicroCopy;
};

export const TotalPrice: FC<Props> = ({ totalPrice, microCopies }) => {
	const { isDesktop } = useBreakpoints();
	const { classes } = useCustomStyles();

	const formattedTotalPrice = usePriceToDecimalString(totalPrice);

	return (
		<tr className={classes.totalPriceRow}>
			<th>
				<Typography variant={isDesktop ? 'bodyMd' : 'bodySm'} as="span">
					{microCopies['common.totalPrice']}
				</Typography>
			</th>
			<td>
				<Typography variant={isDesktop ? 'heading2Xl' : 'headingXl'} as="span" className={classes.title}>
					{formattedTotalPrice}
				</Typography>
			</td>
		</tr>
	);
};
